export default {
    reset_password_title: "Change Password",
    reset_password_message: "Do you want to change the password?, an email  will be sent with the instructions to set the new password",
    reset_password_success_message: "The email has been sent",
    reset_password_error_message: "Unable to sent the email due to an error",
    reset_password_new_password: "New Password",
};